import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();
  const location = useLocation();

  console.log('🛡️ [PROTECTED_ROUTE] Checking access for:', location.pathname, {
    isAuthenticated,
    loading
  });

  // Show loading spinner while checking authentication
  if (loading) {
    console.log('⏳ [PROTECTED_ROUTE] Authentication check in progress...');
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-red-900"></div>
      </div>
    );
  }

  // If not authenticated, redirect to login with return URL
  if (!isAuthenticated) {
    console.log('🚫 [PROTECTED_ROUTE] Access denied - redirecting to login');
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // If authenticated, render the protected component
  console.log('✅ [PROTECTED_ROUTE] Access granted - rendering protected content');
  return children;
};

export default ProtectedRoute;